import {
  IconBlocks,
  IconCertificate,
  IconChargingPile,
  IconChartDots,
  IconChartHistogram,
  IconContract,
  IconFileEuro,
  IconHome,
  IconLayoutDashboard,
  IconListCheck,
  IconMapPins,
  IconReceiptEuro,
  IconServerCog,
  IconSignRight,
  IconSitemap,
  IconUserCog
} from "@tabler/icons-react";
import { ROUTES } from "../../routes";
import type { MenuItemData } from "./Menu.types";
import { Group } from "./Menu.types";

export const MENU_ITEMS = {
  PRODUCT_SELECT_PAGE: {
    label: "Modulauswahl",
    icon: IconBlocks,
    url: ROUTES.productSelectPage,
    group: Group.ModuleChoice,
    showGroups: [Group.TopLevel, Group.ModuleChoice]
  },
  MANAGER_START_PAGE: {
    label: "Startseite",
    icon: IconHome,
    url: ROUTES.startPage,
    group: Group.Manager,
    showGroups: [Group.TopLevel, Group.Manager]
  },
  MANAGER_PROJECT_LIST: {
    label: "Dashboard",
    icon: IconLayoutDashboard,
    url: ROUTES.dashboard,
    group: Group.Manager,
    showGroups: [Group.TopLevel, Group.Manager]
  },
  VERMARKTUNG_PROJECT_LEVEL: {
    label: "Vermarktung",
    icon: IconContract,
    group: Group.Manager,
    showGroups: [Group.TopLevel, Group.Manager],
    url: ROUTES.vermarktung.entryWithProject
  },
  VERMARKTUNG: {
    label: "Vermarktung",
    icon: IconContract,
    group: Group.Manager,
    showGroups: [Group.TopLevel, Group.Manager],
    url: ROUTES.vermarktung.entry
  },
  MANAGER_PROJECT_VIEW: {
    label: "Projektübersicht",
    icon: IconSitemap,
    url: ROUTES.project.entry,
    group: Group.Manager,
    showGroups: [Group.TopLevel, Group.Manager]
  },
  MANAGER_VARIANT_STRUCTURE: {
    label: "Liegenschaft",
    icon: IconMapPins,
    url: ROUTES.site.entry,
    group: Group.ManagerSite,
    showGroups: [Group.TopLevel, Group.Manager, Group.ManagerSite]
  },
  TODOS: {
    label: "Aufgaben",
    icon: IconListCheck,
    url: ROUTES.todos.entry,
    group: Group.Manager,
    showGroups: [Group.TopLevel, Group.Manager]
  },
  ONBOARDING: {
    label: "Onboarding",
    icon: IconSignRight,
    url: ROUTES.onboarding.entry,
    group: Group.Manager,
    showGroups: [Group.TopLevel, Group.Manager]
  },
  ENERGY_DATA: {
    label: "Energiedaten",
    icon: IconChartHistogram,
    url: ROUTES.energyData.entry,
    group: Group.Manager,
    showGroups: [Group.TopLevel, Group.Manager]
  },
  DELIVERY_OVERVIEW: {
    label: "Rechnungen",
    icon: IconFileEuro,
    url: ROUTES.mieterstrom.entry,
    group: Group.Manager,
    showGroups: [Group.TopLevel, Group.Manager]
  },
  GUARANTEE_OF_ORIGIN: {
    label: "Herkunftsnachweis",
    icon: IconCertificate,
    url: ROUTES.guaranteeOfOrigin,
    group: Group.Manager,
    showGroups: [Group.TopLevel, Group.Manager],
    staff: true
  },
  OPTI_CHARGE: {
    label: "opti.charge",
    icon: IconChargingPile,
    group: Group.Manager,
    showGroups: [Group.Manager]
  },
  PARAGRAPH6: {
    label: "§ 6 EEG",
    icon: IconReceiptEuro,
    group: Group.Manager,
    showGroups: [Group.TopLevel, Group.Manager],
    url: ROUTES.paragraph6.entry
  },
  REVENUE_MONITORING: {
    label: "Erlösmonitoring",
    icon: IconChartDots,
    url: ROUTES.revenueMonitoring.entry,
    group: Group.Manager,
    showGroups: [Group.TopLevel, Group.Manager]
  },
  REVENUE_MONITORING_PROJECT_LEVEL: {
    label: "Erlösmonitoring",
    icon: IconChartDots,
    url: ROUTES.revenueMonitoring.entryWithProject,
    group: Group.Manager,
    showGroups: [Group.TopLevel, Group.Manager]
  },
  PPA_INVOICING: {
    label: "PPA - Abrechnung",
    icon: IconFileEuro,
    staff: true,
    group: Group.Manager,
    showGroups: [Group.TopLevel, Group.Manager],
    url: ROUTES.ppa
  },
  API_SETTINGS: {
    label: "API-Einstellungen",
    icon: IconServerCog,
    url: ROUTES.apiSettings,
    group: Group.Manager,
    showGroups: [Group.TopLevel, Group.ModuleChoice],
    persistGroups: true
  },
  ADMIN: {
    label: "Admin",
    icon: IconUserCog,
    staff: true,
    group: Group.TopLevel,
    showGroups: [Group.TopLevel]
  }
} as const satisfies Record<string, MenuItemData>;

export const NAVBAR_SHADOW =
  "1px 0 15px 0 color-mix(in srgb, var(--mantine-color-neutral-6) 10%, transparent)";
export const NAVBAR_SCROLLBAR_COLOR = "var(--mantine-color-neutral-4)";
